import React from "react";
import { Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Hero from "./components/pages/Hero";
import Reviews from "./components/Reviews";
import Footer from "./components/Footer";
import ContactUs from "./components/pages/ContactUs";
import ScrollToTop from "./components/ScrollToTop";
import NotFound from "./components/pages/NotFound";


import "./styles.css";

function App() {
  return (
    <>
      <Navbar />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Hero />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/contact" element={<ContactUs />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
